const CATEGORIES = ['All', 'Animals', 'Fashion', 'Fitness', 'Finance', 'Food', 'Health', 'Lifestyle', 'Tech', 'Travel'];

export { CATEGORIES };
